import { render } from "./buildingtypesForModalComponent.vue?vue&type=template&id=309e7c9b"
import script from "./buildingtypesForModalComponent.vue?vue&type=script&lang=js"
export * from "./buildingtypesForModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__